import React, { useEffect, useState } from "react";
import { Card, Table, message } from "antd";
import { MDBCol, MDBRow } from "mdbreact";
import { Text } from "react-font";
import { Button, SearchInput } from "evergreen-ui";
import Firebase from "../../Firebase/Firebase";
import FireFetch from "../../Firebase/FireFetch";
import ViewActivity from "../../Modals/Feedback/ViewActivity";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { TableExport } from "tableexport";
import { useAuth } from "../../AuthContext/AuthContext";
import TableActionMenu from "../../Common/TableActionMenu";
import { getCallable } from "../../Firebase/functionsClient";

const moment = require("moment");

const columns = [
	{
		title: "Activity",
		dataIndex: "activity",
		key: "activity",
	},
	{
		title: "Worker",
		dataIndex: "assigned",
		key: "assigned",
		sorter: (a, b) =>
			a.assigned && b.assigned && a.assigned.localeCompare(b.assigned),
		responsive: ["sm"],
	},
	{
		title: "Community",
		dataIndex: "community",
		key: "community",
		sorter: (a, b) =>
			a.community && b.community && a.community.localeCompare(b.community),
	},
	{
		title: "Lesson",
		key: "lesson",
		dataIndex: "lesson",
		sorter: (a, b) =>
			a.lesson && b.lesson && a.lesson.localeCompare(b.lesson),
		responsive: ["sm"],
	},
	{
		title: "Origin",
		key: "origin",
		dataIndex: "origin",
		sorter: (a, b) =>
			a.origin && b.origin && a.origin.localeCompare(b.origin),
		responsive: ["sm"],
	},
	{
		title: "Time",
		key: "time",
		dataIndex: "time",
		sorter: (a, b) => moment(a.time).diff(moment(b.time)),
		responsive: ["sm"],
	},
	{
		title: "Action",
		key: "action",
		dataIndex: "action",
	},
];

const auth = getAuth(Firebase);

const Activities = () => {
	const { canAccessModule } = useAuth();
	const canDeleteActivity = canAccessModule("LESSON_ACTIVITIES", "delete");
	const [eventsData, setEventsData] = useState([]);
	const [dataArray, setDataArray] = useState([]);
	const [loading, setLoading] = useState(true);

	const [viewModal, setViewModal] = useState(false);
	const [selectedActivity, setSelectedActivity] = useState(null);
	const [searchValue, setSearchValue] = useState("");

	useEffect(() => {
		const listActivities = getCallable("listActivities");

		const unsubscribe = onAuthStateChanged(auth, (user) => {
			if (!user) {
				window.location.href = "/login";
				return;
			}

			(async () => {
				try {
					setLoading(true);

					const res = await listActivities({});
					console.log(res)
					const activities = res.data || [];

					const rows = activities.map((item, index) => ({
						key: index + 1,
						id: item.id,
						activity: item.activity,
						community: item.community,
						assigned: item.assigned,
						lesson: item.lesson,
						time: item.timeFormatted,
						origin: item.origin,
						_full: item,
						action: (
							<TableActionMenu
								items={[
									{
										key: "view",
										label: "View",
										onClick: () => {
											setSelectedActivity(item);
											setViewModal(true);
										},
									},
									canDeleteActivity && {
										key: "delete",
										label: "Delete",
										danger: true,
										onClick: () => {
											if (!canDeleteActivity) {
												message.error("You do not have permission to delete activities.");
												return;
											}

											if (confirm("Are you sure you want to delete activity?")) {
												FireFetch.DeleteFromDB("activities", item.id)
													.then((message) => {
														if (message === "success") {
															FireFetch.addLog("activities", item.id, "Delete");
															alert("Activity deleted");
														} else {
															alert("Unable to delete");
														}
													})
													.catch(() => {
														alert("Unable to delete");
													});
											}
										},
									},
								]}
							/>
						),
					}));

					setDataArray(rows);
					setEventsData(rows);
				} catch (error) {
					console.error("Error fetching activities from Cloud Function:", error);
				} finally {
					setLoading(false);
				}
			})();
		});

		return () => unsubscribe();
	}, [canDeleteActivity]);

	const handleSearch = (value) => {
		const searchText = (value || "").toLowerCase();

		if (!searchText) {
			setEventsData(dataArray);
			return;
		}

		const filteredEvents = dataArray.filter(
			({ lesson, community, assigned, time }) => {
				const c = community && community.toLowerCase();
				const a = assigned && assigned.toLowerCase();
				const l = lesson && lesson.toLowerCase();
				const t = time && time.toLowerCase();

				return (
					(l && l.includes(searchText)) ||
					(c && c.includes(searchText)) ||
					(a && a.includes(searchText)) ||
					(t && t.includes(searchText))
				);
			}
		);

		setEventsData(filteredEvents);
	};

	return (
		<div className="d-flex justify-content-center align-items-center pt-4 mt-4">
			<MDBRow className="w-100">
				<MDBCol md={12}>
					<Card className="w-100">
						<MDBRow>
							<MDBCol>
								<div className="text-left">
									<div className="d-flex flex-row justify-content-between">
										<div className="d-inline">
											<h5
												className="font-weight-bold"
												style={{ color: "#51195D" }}
											>
												<Text family="Nunito">Lesson Activities</Text>
											</h5>
										</div>
										<div className="d-flex flex-row">
											<SearchInput
												placeholder="Filter through lessons or communities"
												className="mx-1"
												value={searchValue}
												onChange={(e) => {
													const value = e.target.value;
													setSearchValue(value);
													handleSearch(value);
												}}
											/>
											<Button
												intent="primary"
												appearance="primary"
												onClick={() => {
													FireFetch.exportXL(
														TableExport(
															document.getElementById("dataTable"),
															{
																filename: "Activities",
																exportButtons: false,
																sheetname: "Activities",
															}
														),
														eventsData
													);
												}}
												className="d-inline mx-1 float-right"
											>
												Print
											</Button>
										</div>
									</div>
								</div>
							</MDBCol>
						</MDBRow>
					</Card>

					<Card>
						<Table
							className="custom-table"
							id="dataTable"
							loading={loading}
							pagination={{
								defaultPageSize: 100,
								showSizeChanger: true,
								pageSizeOptions: ["100", "200", "300"],
							}}
							style={{ overflow: "auto" }}
							locale={{ emptyText: "No lesson activities found." }}
							columns={columns}
							dataSource={eventsData}
						/>
					</Card>

					{viewModal && selectedActivity && (
						<ViewActivity
							isOpen={viewModal}
							toggle={() => setViewModal(false)}
							activity={selectedActivity}
						/>
					)}
				</MDBCol>
			</MDBRow>
		</div>
	);
};

export default Activities;
